const WORDS = [
  "Lady Latina",
  "Bachata",
  "Salsa",
  "Жіночність",
  "Пластика",
  "Впевненість",
  "Wrocław",
  "Grand Dance Studio",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="relative border-y border-white/5 py-5 sm:py-7 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee-slow items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif-display italic font-light text-2xl sm:text-4xl text-white/60 px-6 sm:px-10">
              {w}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#A01828]/70 shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
